import React from 'react';
import { ToolbarButton } from '@marvelapp/ui';
import { HandoffIcon } from './icons';
export default function SidebarHandoff(_a) {
    var onClick = _a.onClick, isActive = _a.isActive;
    return (React.createElement(ToolbarButton, { alignItems: "center", display: "flex", fill: "slate", fontFamily: 0, isActive: isActive, onClick: onClick },
        React.createElement(HandoffIcon, { display: "block", marginLeft: "-2px", marginRight: "10px" }),
        "Handoff"));
}
